import { IAreaTargetFormation } from '../../interfaces/iarea-target-formation';
import { Scenario } from '../scenario';
import { TargetFormation } from '../target-formation';

export class AreaTargetFormationBase {
  AreaTargetFormationId: number;
  ScenarioId: number;
  AreaTypeId: number;
  AreaId: number | null;
  TargetFormationId: number;
  TargetFormationAllowedId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Scenario?: Scenario;
  TargetFormation?: TargetFormation;
  TargetFormationAllowed?: TargetFormation;

  constructor(item?: IAreaTargetFormation) {
    if (item) {

      this.AreaTargetFormationId = item.AreaTargetFormationId;
      this.ScenarioId = item.ScenarioId;
      this.AreaTypeId = item.AreaTypeId;
      this.AreaId = item.AreaId;
      this.TargetFormationId = item.TargetFormationId;
      this.TargetFormationAllowedId = item.TargetFormationAllowedId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Scenario = new Scenario(item.Scenario);
      this.TargetFormation = new TargetFormation(item.TargetFormation);
      this.TargetFormationAllowed = new TargetFormation(item.TargetFormationAllowed);
    }
  }
}